import { render, staticRenderFns } from "./webmd.vue?vue&type=template&id=61fa55c0&scoped=true&v-once=true"
import script from "./webmd.vue?vue&type=script&lang=js"
export * from "./webmd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa55c0",
  null
  
)

export default component.exports